import $ from 'jquery'
import Recaptcha from '../../utils/recaptcha'
import ScrollHelper from '../../utils/scroll-helper'
import { CLEVERREACH_SITE_KEY } from '../../constants/recaptcha'

const INVALID_CLASS = 'is-invalid'
const BTN_DISABLED_CLASS = 'btn--outline'

const escapeName = name => {
  return name.replace(/([ #;?%&,.+*~':"!^$[\]()=>|/@])/g, '\\$1')
}

class ActionForm {
  constructor(selector = '.action-form') {
    this.$form = $('form', selector)
    this.form = this.$form.get(0)

    // Exit if no registration form is present
    if (!this.form) {
      return
    }

    this.inputs = $('input', this.form)
    this.textInputs = $('.form-control', this.form)
    this.checkboxInputs = $('.form-check-input', this.form)

    this.recaptchaContainer = $('.g-recaptcha', this.form).get(0)
    this.submitButton = $('.form-action .btn', this.form)

    this.recaptchaValid = false

    this.init()
  }

  init() {
    this.initRecaptcha()
    this.listen()
  }

  listen() {
    // listen to form submits
    this.$form.on('submit', event => {
      this.submit(event)
    })

    // validate on focus out events (gets selects & text like inputs)
    this.textInputs.on('blur change', event => {
      this.showInputsValidationStatus(event.target)
    })

    // validate on click events
    this.checkboxInputs.on('click', event => {
      const checkbox = $(event.target)
      const checkboxGroup = $('input[name=' + escapeName(checkbox.attr('name')) + ']')

      this.showInputsValidationStatus(checkboxGroup)
    })

    // make submit button be aware of all inputs
    this.inputs.on('input', () => {
      this.setSubmitButtonState()
    })
  }

  submit(event) {
    event.preventDefault()
    const valid = this.validateForm()

    if (valid) {
      return this.form.submit()
    }

    const inputs = this.textInputs.add(this.checkboxInputs)
    this.showInputsValidationStatus(inputs)
    this.scrollToFirstInvalidInput()
  }

  scrollToFirstInvalidInput() {
    const el = $('.is-invalid', this.form).first()
    ScrollHelper.scrollToElement(el)
  }

  getRequiredInputsValidationStatus() {
    const requiredInputs = $('input[required]', this.form).toArray()

    return requiredInputs.every(input => {
      return input.validity.valid
    })
  }

  showInputsValidationStatus(inputs) {
    // wrap the inputs as jquery object to handle single & array values
    $(inputs)
      .toArray()
      .forEach(input => {
        !input.validity.valid
          ? $(input).addClass(INVALID_CLASS)
          : $(input).removeClass(INVALID_CLASS)
      })
  }

  validateForm() {
    return this.getRequiredInputsValidationStatus() && this.recaptchaValid
  }

  setSubmitButtonState() {
    !this.validateForm()
      ? this.submitButton.addClass(BTN_DISABLED_CLASS)
      : this.submitButton.removeClass(BTN_DISABLED_CLASS)
  }

  initRecaptcha() {
    Recaptcha.render(
      this.recaptchaContainer,
      CLEVERREACH_SITE_KEY,
      this.recaptchaSuccess.bind(this),
      this.recaptchaExpired.bind(this)
    )
  }

  recaptchaSuccess() {
    this.recaptchaValid = true
    this.setSubmitButtonState()
  }

  recaptchaExpired() {
    this.recaptchaValid = false
    this.setSubmitButtonState()
  }
}

export default ActionForm
